import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-details",
  "use": "icon-details-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-details\"><path d=\"M298.666667 341.333333h384v42.666667H298.666667v-42.666667z m0 128h298.666666v42.666667H298.666667v-42.666667z m0 128h298.666666v42.666667H298.666667v-42.666667zM170.666667 128h682.666666v554.666667h42.666667V106.517333c0-11.52-9.557333-21.184-21.333333-21.184H149.333333c-11.626667 0-21.333333 9.557333-21.333333 21.376v810.581334C128 929.066667 137.557333 938.666667 149.333333 938.666667h490.666667v-42.666667H170.666667V128z m469.333333 576.042667c0-11.797333 9.728-21.376 21.376-21.376H896L640 938.666667V704.042667z m153.002667 21.290666H682.666667v110.336L793.002667 725.333333z\" fill=\"#3D3D3D\" p-id=\"2367\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/details.svg
// module id = MIkI
// module chunks = 42